/* Quarry — record reactions.
   Honest by design: the number shown is the baseline stored on the record plus
   THIS visitor's own vote. Without a configured endpoint there is no shared
   count, and the code never invents one. With an endpoint, the server's counts
   replace the local figure on load. */
(function () {
  var KEY = 'if_react_v1';

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
  }
  function save(v) {
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode */ }
  }

  function paint(bar, votes) {
    var id = bar.dataset.record;
    var mine = votes[id] || null;
    ['like', 'dislike'].forEach(function (kind) {
      var btn = bar.querySelector('[data-vote="' + kind + '"]');
      if (!btn) return;
      var base = parseInt(bar.dataset[kind === 'like' ? 'baseLike' : 'baseDislike'], 10) || 0;
      var server = bar.dataset[kind === 'like' ? 'serverLike' : 'serverDislike'];
      var shown = server !== undefined ? parseInt(server, 10) : base + (mine === kind ? 1 : 0);
      btn.querySelector('[data-count]').textContent = shown;
      btn.setAttribute('aria-pressed', mine === kind ? 'true' : 'false');
    });
  }

  function init(root) {
    var endpoint = root.dataset.endpoint || '';
    var bars = root.querySelectorAll('[data-qreact]');
    if (!bars.length) return;
    var votes = load();

    bars.forEach(function (bar) {
      paint(bar, votes);

      bar.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-vote]');
        if (!btn) return;
        var id = bar.dataset.record, kind = btn.dataset.vote;
        var prev = votes[id] || null;
        votes[id] = (prev === kind) ? null : kind;   // clicking the same one again clears it
        save(votes);
        paint(bar, votes);

        if (!endpoint) return;
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ record: id, vote: votes[id], previous: prev })
        }).then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            if (!d) return;
            if (typeof d.likes === 'number') bar.dataset.serverLike = d.likes;
            if (typeof d.dislikes === 'number') bar.dataset.serverDislike = d.dislikes;
            paint(bar, votes);
          })
          .catch(function () { /* the local state already stands */ });
      });
    });

    /* Impressions: one per record per browser session, and only when there is
       somewhere to send them. No endpoint means no impression tracking, rather
       than a number that means nothing. */
    if (!endpoint || !('IntersectionObserver' in window)) return;
    var seen = {};
    try { seen = JSON.parse(sessionStorage.getItem(KEY + '_seen') || '{}'); } catch (e) {}
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var bar = en.target, id = bar.dataset.record;
        io.unobserve(bar);
        if (seen[id]) return;
        seen[id] = 1;
        try { sessionStorage.setItem(KEY + '_seen', JSON.stringify(seen)); } catch (e) {}
        fetch(endpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ record: id, impression: true })
        }).catch(function () {});
      });
    }, { threshold: 0.5 });
    bars.forEach(function (b) { io.observe(b); });
  }

  function boot() {
    document.querySelectorAll('[data-qrec]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
